module.exports = __webpack_public_path__ + "Flag-124.70bfdf38e44f490a322337224c899764.svg";